/**
 * Display helpers for forecast growth/shrinkage factors. A factor is stored as
 * a multiplier (`1.15`); buyers read it as a percentage (`+15%`), so every
 * surface that shows one goes through here rather than rounding on its own.
 */

/** `1.15` reads as `+15%`, `0.9` as `-10%`. */
export function formatFactorPercent(factor: number): string {
  const pct = Math.round((factor - 1) * 1000) / 10;
  return `${pct > 0 ? '+' : ''}${pct}%`;
}
